module.exports = __webpack_public_path__ + "img/Icon-Video.b7856031.svg";